<template>
  <a 
    v-show="showButton"
    href="/calendar" 
    class="btn-calendar"
  >
    <span>{{ __('Ver no calendário') }}</span>
  </a>
</template>

<script>
import axios from 'axios';

export default {
  props: ['hash'],
  
  data() {
    return {
      hasActivitiesToday: false,
      isActivitiesTab: false,
      activities: [],
      showButton: false
    }
  },

  mounted() {
    this.checkTodayActivities();
    
    Bus.$on('activityCreatedWithSchedule', this.checkTodayActivities);
    Bus.$on('activity-deleted', this.checkTodayActivities);

    document.querySelectorAll('.btn-switch').forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          this.updateCalendarButtonVisibility();
        }, 0);
      });
    });
  },

  beforeDestroy() {
    Bus.$off('activityCreatedWithSchedule', this.updateCalendarButtonVisibility);
    Bus.$off('activity-deleted', this.updateCalendarButtonVisibility);

    document.querySelectorAll('.btn-switch').forEach(button => {
      button.removeEventListener('click', this.updateCalendarButtonVisibility);
    });
  },

  methods: {
    checkTodayActivities() {
      axios.get(`/lead/${this.hash}/activity`)
        .then(response => {
          this.activities = response.data.data;
          this.updateCalendarButtonVisibility();
        });
    },

    updateCalendarButtonVisibility() {
        const hasActivitiesToday = this.activities?.some(activity => {
          const activityDate = new Date(activity.scheduled_at);
          const today = new Date();
          return activityDate.toDateString() === today.toDateString() && !activity.deleted_at;
        });

        const activeButton = document.querySelector('.btn-switch.active');
        const activeTab = activeButton ? activeButton.getAttribute('data-target') : '';

        this.showButton = (activeTab === 'activities' && hasActivitiesToday);
    }
  }
}
</script>